<template>
  <div class="s-modal__wrapper s-modal__wrapper--white">
    <!-- Header -->
    <div class="s-modal__header s-modal__header--transparent">
      <button id="s-modal-close"
              type="button"
              class="s-modal__btn--close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('closePopup')"></button>
    </div>

    <!-- Main Content -->
    <div class="s-modal__body s-modal__body--start">
      <div class="s-modal-content--start--text">
        <p class="s-modal__txt--start s-modal__txt--start__title">{{data.title}}</p>
        <p class="s-modal__txt--start s-modal__txt--start__desc" :class="{ min: isJb && text.length > 100 }" v-html="text"></p>
      </div>
      <div class="s-modal-content--start--btn">
        <div class="s-modal__thumb--start" :class="{ peng: type === 'runner', jb: isJb }">
        </div>
        <div class="s-modal__btn--ws s-modal__btn--ws--single s-modal__btn--start"
             @click="confirm">{{isLast ? '시작하기' : '다음'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'modalStartTemplate',
      props : {
        data: {
          type: Object,
          default: function () {
            return {
              title: '',
              desc: [{
                text: '',
                image: ''
              }]
            }
          }
        },
        type: {},
        isJb: {}
      },
      data() {
        return {
          nowIndex: 0
        }
      },
      computed: {
        isLast() {
          return typeof this.data.desc === 'undefined'
            || this.data.desc === null
            || !Array.isArray(this.data.desc)
            || this.data.desc.length === 0
            || this.nowIndex === (this.data.desc.length - 1)
        },
        text() {
          return (this.data.desc.length ? this.data.desc[this.nowIndex].text : '')//.replace(/https:\/\/s3.ap-northeast-2.amazonaws.com/, '/codmos/static/assets')
        }
      },
      methods: {
        confirm() {
          if (this.isLast) {
            this.$emit('closePopup')
            this.nowIndex = 0;
          } else this.nowIndex++
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/stage/modal/ModalPartialStart.vue